// Soft synthesized industrial notification chime via Web Audio API (no asset needed).
let ctx;
function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  return ctx;
}

export function alertSoundEnabled() {
  return localStorage.getItem("ngx_alert_sound") !== "off";
}

export function setAlertSound(on) {
  localStorage.setItem("ngx_alert_sound", on ? "on" : "off");
}

// type: 'decision' (soft two-tone up) | 'safety' (lower, more serious but not a siren)
export function playChime(type = "decision") {
  try {
    const c = getCtx();
    if (!c) return;
    if (c.state === "suspended") c.resume();
    const now = c.currentTime;
    const tones = type === "safety" ? [[494, 0], [392, 0.2]] : [[880, 0], [1174.66, 0.14]];
    tones.forEach(([freq, dt]) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      osc.connect(gain);
      gain.connect(c.destination);
      const t = now + dt;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.14, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0008, t + 0.38);
      osc.start(t);
      osc.stop(t + 0.42);
    });
  } catch (e) {
    /* audio not available */
  }
}
